import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyText: {
		id: 'atlassian-navigation.projects.menu.empty.empty-text',
		defaultMessage: 'Make the most of your Atlassian products by extending them with projects.',

		description: 'Suggest an action to the user',
	},
	learnMore: {
		id: 'atlassian-navigation.projects.menu.empty.learn-more',
		defaultMessage: 'Learn more',

		description: 'Suggest user click on the link to learn more about projects in jira',
	},
	emptyImg: {
		id: 'atlassian-navigation.projects.menu.empty.empty-img',
		defaultMessage: 'An image showing that the projects dropdown menu is empty',
		description: 'Alt text for empty view',
	},
});
